import React, {Fragment, forwardRef} from 'react';
import {NoWrap} from 'components';
import {padStart, getElementAttributes, secondsToTime} from 'helpers';

export const Duration = forwardRef(({ value, forceSeconds, hideSeconds, ...props }, ref) => {
  let { hours, minutes, seconds } = secondsToTime(value);

  if (hours == 24) {
    return (
      <NoWrap>All day</NoWrap>
    );
  }

  seconds = padStart(seconds, 2, 0);
  if (hours) {
    minutes = padStart(minutes, 2, 0);
  }

  return (
    <NoWrap {...getElementAttributes(props)} ref={ref}>
      { hours > 0 && <Fragment>{ hours }<small>h</small></Fragment> }
      {' '}
      { minutes }<small>m</small>
      {' '}
      { (!hours && !hideSeconds || forceSeconds) &&
        <Fragment>{ seconds }<small>s</small></Fragment>
      }
    </NoWrap>
  );
});
